import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BackgroundMusicApi } from "../api/background-music-api";

export function useBeatSyncsQuery(
  teamExternalId: string,
  backgroundMusicExternalId: string | undefined,
) {
  return useQuery({
    queryKey: beatSyncQueryKeys.getBeatSyncs(
      teamExternalId,
      backgroundMusicExternalId,
    ),
    queryFn: () =>
      BackgroundMusicApi.getBeatSyncs(
        teamExternalId,
        backgroundMusicExternalId!,
      ),
    enabled: !!teamExternalId && !!backgroundMusicExternalId,
  });
}

export function useInvalidateBeatSyncsQuery() {
  const queryClient = useQueryClient();

  return (teamExternalId: string, backgroundMusicExternalId: string) =>
    queryClient.invalidateQueries({
      queryKey: beatSyncQueryKeys.getBeatSyncs(
        teamExternalId,
        backgroundMusicExternalId,
      ),
    });
}

export const beatSyncQueryKeys = {
  getBeatSyncs: (
    teamExternalId: string,
    backgroundMusicExternalId: string | undefined,
  ) => ["beat-sync", "list", { teamExternalId, backgroundMusicExternalId }],
};
